/* «Читати далі» / «Читати повністю»: a [data-readmore] text is folded to its CSS max-height (class is-clamped);
   the [data-readmore-btn] next to it appears only when the text is really longer, and unfolds it for good.
   The whole text is in the page either way (search engines read it). Used by sections/t-collection («Про
   колекцію») and sections/brand-story. */
(() => {
  if (window.readMoreReady) return;
  window.readMoreReady = true;
  const boxes = () => document.querySelectorAll('[data-readmore]');
  const check = (box) => {
    const btn = box.parentElement.querySelector('[data-readmore-btn]');
    if (btn) btn.hidden = box.classList.contains('is-open') || box.scrollHeight <= box.clientHeight + 2;
  };
  const init = () => boxes().forEach((box) => {
    check(box);
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const btn = box.parentElement.querySelector('[data-readmore-btn]');
    if (btn) btn.addEventListener('click', () => { box.classList.add('is-open'); btn.hidden = true; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', () => boxes().forEach(check)); // web fonts can change the height
  window.addEventListener('resize', () => boxes().forEach(check));
})();
